
import { PlayerEventType, PlayBackState } from '../model/playerEventModel';

let footerStatus = false;
const handleFooterStatus = (event, showFooter) => {
    const { eventType, instantEventType, state, data } = event;
    const updateFooterStatus = (status) => {
        showFooter(status);
        footerStatus = status;
    };

    if (eventType === PlayerEventType.InstantEvent && instantEventType === 'scroll') {
        if (data.offsetHeight + data.scrollTop >= (data.scrollHeight - 3) && !footerStatus) {
            updateFooterStatus(true);
        } else if (data.offsetHeight + data.scrollTop < data.scrollHeight && footerStatus) {
            updateFooterStatus(false);
        }
    }

    if (state === PlayBackState.Ended && !footerStatus) {
        updateFooterStatus(true);
    } else if (state === PlayBackState.Playing && footerStatus) {
        updateFooterStatus(false);
    }
};

export default handleFooterStatus;
